module.exports = __webpack_public_path__ + "img/16.735a7a01.png";